// utils/addJitsiWidgetLite.ts ----------------------------------------------
import { MatrixClient }     from "matrix-js-sdk";
import { base32 }           from "rfc4648";
import { secureRandomString } from "matrix-js-sdk/src/randomstring";

type Params = {
  client:      MatrixClient;
  roomId:      string;
  roomName?:   string;
  jitsiDomain: string;               // e.g. "call.ssh.sshcollabx.net"
  useJwt?:     boolean;              // true if your Jitsi uses OpenID-JWT
  isVideoChannel?: boolean;          // always true for “video rooms”
  ifExternalMeeting?: boolean;       // your custom flag (optional)
};

export async function addJitsiWidgetLite({
  client,
  roomId,
  roomName,
  jitsiDomain,
  useJwt = false,
  isVideoChannel = true,
  ifExternalMeeting = false,
}: Params) {
  // 1. widget & conference IDs
  const widgetId = "jitsi_" + secureRandomString(24);
  const confId   = useJwt
      ? base32.stringify(new TextEncoder().encode(roomId), { pad:false })
      : "Jitsi" + secureRandomString(24);

  // 2. Element’s standard wrapper URL (keep the $variables intact!)
  const wrapper = new URL("/jitsi.html", window.location.origin);
  wrapper.hash  = [
    `conferenceDomain=$domain`,
    `conferenceId=$conferenceId`,
    `roomId=$matrix_room_id`,
    `isVideoChannel=$isVideoChannel`,
    `displayName=$matrix_display_name`,
    `avatarUrl=$matrix_avatar_url`,
    `userId=$matrix_user_id`,
    `theme=$theme`,
    `roomName=$roomName`,
    `language=$org.matrix.msc2873.client_language`,
    ifExternalMeeting ? "ifExternalMeeting=$ifExternalMeeting" : "",
  ].filter(Boolean).join("&");

  // 3. full “content” payload the widget manager expects
  const content = {
    type: "jitsi",                       // legacy widget type
    url:  wrapper.toString(),
    name: roomName ?? confId,
    data: {
      conferenceId:   confId,
      roomName:       roomName,
      isAudioOnly:    false,
      isVideoChannel: isVideoChannel,
      domain:         jitsiDomain,
      auth:           useJwt ? "openidtoken-jwt" : undefined,
      ifExternalMeeting,
    },
    creatorUserId: client.getUserId(),
    id:            widgetId,
    waitForIframeLoad: true,
  };

  // 4. write it into room state
  await client.sendStateEvent(
      roomId,
      "im.vector.modular.widgets",   // event type
      content,
      widgetId                       // <–– state_key
  );
}
